import CarSliderContainer from "../../../components/car/detail/CarSlider";

const CarSlider = () => {
  return <CarSliderContainer />;
};

export default CarSlider;
